module.exports = __webpack_public_path__ + "img/bespoke70_34.5fad61e4.jpg";